module.exports = require('./$.global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.path.js
 ** module id = 84
 ** module chunks = 0
 **/